/* global Blob */
import React from 'react';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { connect } from 'react-redux';
import * as rawMaterial from '~/actions/rawMaterial';
import { Button } from 'react-toolbox/lib/button';
import Dropdown from 'react-toolbox/lib/dropdown';
import Table from 'react-toolbox/lib/table';
import Spinner from '~/components/Spinner';
import Tag from '~/components/Tag';
import styleLocal from './style.scss';

const rawMaterialCategories = [
  { value: null, label: 'Not Set' },
  { value: 'stickers', label: 'Stickers' },
  { value: 'bottle caps', label: 'Bottle Caps' },
  { value: 'bottles', label: 'Bottles' },
  { value: 'bags', label: 'Bags' },
  { value: 'boxes', label: 'Boxes' },
  { value: 'powders', label: 'Powders' },
  { value: 'liquids', label: 'Liquids' },
];

class Production extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { loading: true, results: [], query: '' };
  }

  componentDidMount() {
    this.search();
  }

  search() {
    this.setState({ loading: true });
    rawMaterial.list2(this.props.dispatch, this.context.apiClient, this.state.query, null)
      .then(r => this.setState({
        results: r.data.results,
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  loadMore() {
    this.setState({ loading: true });
    rawMaterial.list2(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.skipId
    )
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  export(data) {
    const workbook = {
      SheetNames: ['Data'],
      Sheets: { Data: XLSX.utils.json_to_sheet(data) }
    };
    const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
    const wbout = XLSX.write(workbook, wopts);
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'RawMaterials.xlsx');
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <div className={styleLocal.header}>
          <span>Raw Material</span>
          <Button
            label="Export .xlsx"
            icon="file_download"
            accent
            raised
            onClick={() => this.export(this.state.results)}
          />
          <Button
            label="Verify"
            onClick={() => this.context.dialogPush('rawMaterialVerify')}
            primary
            raised
            icon="compare_arrows"
          />
          <Button
            label="Move"
            onClick={() => this.context.dialogPush('rawMaterialMove')}
            primary
            raised
            icon="compare_arrows"
          />
          <Button
            label="New"
            onClick={() => this.context.dialogPush('rawMaterial', { onCreate: () => this.search() })}
            primary
            raised
            icon="add"
          />
        </div>

        <form style={{ marginBottom: 15 }} onSubmit={e => { e.preventDefault(); this.search(); }}>
          <input
            placeholder="Search Name, UPC, SKU or ID"
            className={styleLocal.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
          />
          <Button label="Find" primary raised type="submit" />
        </form>
        <div className={styleLocal.filters}>
          <div className={styleLocal.filter}>
            <div className={styleLocal.item}>
              <b>Filters</b>
            </div>
          </div>
          <div className={styleLocal.filter}>
            <div className={styleLocal.item}>
              <Dropdown
                auto={false}
                label="Category"
                onChange={filterCategory => this.setState({ filterCategory })}
                source={rawMaterialCategories}
                value={this.state.filterCategory}
              />
            </div>
          </div>
        </div>
        {!this.state.loading && this.state.results.length === 0 && 'No Raw Materials found'}
        {!this.state.loading && this.state.results.length > 0 && <Table
          className={styleLocal.table}
          selectable={false}
          model={{
            name: { type: String },
            category: { type: String },
            type: { type: String }
          }}
          source={Object.values(this.props.rawMaterials).filter(i => {
            if (!this.state.results.find(x => x.id === i.id)) {
              return false;
            }

            if (this.state.filterCategory && this.state.filterCategory !== i.category) {
              return false;
            }

            return true;
          })
            .map(i => {
              const c = rawMaterialCategories.find(x => x.value === i.category);
              return {
                ...i,
                name: (<Tag id={i.id} type="rawMaterial" />),
                category: c ? c.label : rawMaterialCategories[0].label
              };
            })}
        />}
        {this.state.loading && <Spinner className={styleLocal.spinner} />}
        {!this.state.loading && this.state.more && <Button
          label="Load more"
          disabled={this.state.loading}
          primary
          raised
          onClick={() => this.loadMore()}
          className={styleLocal.buttonLoadMore}
        />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  rawMaterials: state.getIn(['rawMaterial', 'items']).toJS(),
});

export default connect(mapStateToProps)(Production);



// WEBPACK FOOTER //
// ./app/pages/RawMaterials/index.js